module.exports = __webpack_public_path__ + "img/mobile/BetBar/logo@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/logo@3x.png
// module id = 186
// module chunks = 0